function numericIdOf(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value !== 'string' || !value.trim()) return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function yearOf(value: unknown): number {
  if (typeof value === 'string' && value.length >= 4) {
    const year = Number(value.slice(0, 4));
    if (Number.isInteger(year) && year >= 1900) return year;
  }
  return new Date().getFullYear();
}

interface ApplicationDocLike {
  applicationNo?: unknown;
  id?: unknown;
  applicationId?: unknown;
  applicationDate?: unknown;
  createdAt?: unknown;
}

export function formatApplicationDocDisplayId(doc: ApplicationDocLike | null | undefined): string {
  const applicationNo = typeof doc?.applicationNo === 'string' ? doc.applicationNo.trim() : '';
  if (applicationNo) return applicationNo;

  const numericId = numericIdOf(doc?.id ?? doc?.applicationId);
  if (numericId == null) return '—';

  return `AP-${yearOf(doc?.applicationDate ?? doc?.createdAt)}-${String(numericId).padStart(4, '0')}`;
}

export function normalizeJapaneseName(value: unknown): string {
  const raw = String(value ?? '');
  const hasEmptyLastNameMarker = raw.startsWith('\u3000') && raw.replace(/^\u3000+/, '').trim().length > 0;
  const trimmed = raw.replace(/^[\s\u3000]+|[\s\u3000]+$/g, '');
  const normalized = trimmed.replace(/[\s\u3000]+/g, '\u3000');
  return hasEmptyLastNameMarker && normalized ? `\u3000${normalized}` : normalized;
}

export function splitJapaneseName(value: unknown): { lastName: string; firstName: string } {
  const raw = String(value ?? '');
  const idx = raw.indexOf('　');
  if (idx < 0) return { lastName: raw, firstName: '' };
  return { lastName: raw.slice(0, idx), firstName: raw.slice(idx + 1) };
}

export function joinJapaneseName(lastName: unknown, firstName: unknown): string {
  const last = String(lastName ?? '');
  const first = String(firstName ?? '');
  if (!last && !first) return '';
  if (!first) return last;
  return `${last}\u3000${first}`;
}

export function japaneseNameDisplay(value: unknown): string {
  const { lastName, firstName } = splitJapaneseName(normalizeJapaneseName(value));
  if (lastName && firstName) return `${lastName}\u3000${firstName}`;
  return lastName || firstName;
}
